import moment from "moment";
import React from "react";
import { CloseButton, Col, Form, Row } from "react-bootstrap";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import PortalModal from "../../Portals/PortalModal.jsx";
import Select from "react-select";
import { theme as themeConfig } from "../../themes/themes";
import {
  ButtonCancel,
  ButtonCreateGroup,
  ContainFormCheck,
  FormCard,
  FormForCheck,
  FormLabelCheck,
  SelectModalStyles,
} from "./ModalRecurrence.styled";
import {
  Hr,
  SectionWrapper,
  TextTitleList,
} from "../SurveyConfigurationForm/SurveyConfiguration.styled";

const ModalRecurrence = ({
  isEvent,
  closeRecurring,
  onStartRecurring,
  setOnStartRecurring,
  onStartTimeRecurring,
  setOnStartTimeRecurring,
  loadingCreateRecurrence,
  activateRepeatEvery,
  setActivateRepeatEvery,
  repeatEvery,
  setRepeatEvery,
  dateOptions,
  periodRecurring,
  setPeriodRecurring,
  dataButtonDays,
  dataButtonDaysValue,
  optionForMonth,
  optionForMonthSelected,
  setOptionForMonthSelected,
  dataEndsDate,
  activeEndsRecurring,
  setActiveEndsRecurring,
  onEndRecurring,
  setOnEndRecurring,
  onEndTimeRecurring,
  setOnEndTimeRecurring,
  showUpdateRecurringButton,
  createRecurring,
  updateRecurring,
  handleDayChange,
}) => {
  return (
    <>
      <PortalModal>
        <FormCard
          className="configuration-popup"
          style={{ maxHeight: "100%", minHeight: "50%" }}
        >
          <Row className="mx-2 mt-2">
            <Row
              className="mb-0 configuration-header"
              style={{ height: "fit-content" }}
            >
              <Col md="6">
                <TextTitleList className="font-weight-bold mx-2 my-2">
                  Configuration
                </TextTitleList>
              </Col>
              <Col
                md="6"
                className="d-flex justify-content-end align-items-center close-recurring"
              >
                <CloseButton onClick={() => closeRecurring()}></CloseButton>
              </Col>
            </Row>
            <Hr className="mt-0" />
            {!isEvent && (
              <Col md="12">
                <Row>
                  <Col md="12">
                    <Form.Label style={{ color: themeConfig.primary.icon }}>
                      Starts On:
                    </Form.Label>{" "}
                    <span style={{ color: themeConfig.status.error }}>*</span>
                  </Col>
                  <Col md="5">
                    <Form.Control
                      type="date"
                      required={true}
                      value={
                        onStartRecurring?._i
                          ? onStartRecurring._i
                          : onStartRecurring
                      }
                      onChange={(e) => {
                        if (e.currentTarget.value !== "") {
                          setOnStartRecurring(
                            moment(e.currentTarget.value).format("YYYY-MM-DD")
                          );
                        }
                      }}
                      placeholder="Feb 28, 2021"
                    />
                  </Col>
                  <Col
                    md="7"
                    className="d-flex justify-space-between align-items-center"
                  >
                    <Form.Control
                      className="w-50 mr-3"
                      type="time"
                      required={true}
                      value={
                        onStartTimeRecurring?._i
                          ? onStartTimeRecurring._i
                          : onStartTimeRecurring
                      }
                      onChange={(e) => {
                        if (e.currentTarget.value !== "") {
                          setOnStartTimeRecurring(
                            moment(e.currentTarget.value)
                          );
                        }
                      }}
                      placeholder=""
                    />
                    {/*
                    <b className="utc-label">UTC</b>
                    <Tooltip
                      arrow
                      className="ml-2"
                      title="Please take into account that all times are in UTC time when setting your survey time"
                      placement="right"
                    >
                      <InfoIcon
                        style={{ color: themeConfig.primary.purple, cursor: "pointer" }}
                      />
                    </Tooltip>*/}
                  </Col>
                </Row>
              </Col>
            )}
            {!isEvent && (
              <Col md="12">
                <Form.Check
                  inline
                  style={{ fontWeight: "bold" }}
                  label="This survey will repeat every"
                  type="checkbox"
                  id={`active-repeat-every`}
                  name={`active-repeat-every`}
                  defaultChecked={activateRepeatEvery}
                  value={activateRepeatEvery}
                  onChange={(e) => {
                    setActivateRepeatEvery(!activateRepeatEvery);
                  }}
                />
              </Col>
            )}
            {(activateRepeatEvery || isEvent) && (
              <Col md="6" className="m-top-25">
                <Form.Label style={{ color: themeConfig.text.primary }}>
                  Repeat every
                </Form.Label>{" "}
                <span style={{ color: themeConfig.status.error }}>*</span>
                <Form.Control
                  className="repeat-every-input"
                  required={activateRepeatEvery || isEvent}
                  placeholder="Change value"
                  min="1"
                  maxLength="12"
                  name="repeat-every"
                  type="number"
                  value={repeatEvery ? repeatEvery : ""}
                  onChange={(evt) => {
                    let item = evt.currentTarget.value.replace(/(e|E)/, "");
                    let limit = 12;
                    if (Number(item.length) > limit) {
                      setRepeatEvery();
                    } else {
                      let re = /^[0-9\b]+$/;
                      if (item === "" || (re.test(item) && Number(item) > 0)) {
                        setRepeatEvery(item);
                      } else {
                        setRepeatEvery();
                      }
                    }
                  }}
                />
              </Col>
            )}
            {(activateRepeatEvery || isEvent) && (
              <Col md="6" className=" m-top-33">
                <Form.Label></Form.Label>
                <Select
                  placeholder="..."
                  required={activateRepeatEvery}
                  options={dateOptions}
                  styles={SelectModalStyles}
                  defaultValue={
                    dateOptions[
                    dateOptions.findIndex((f) => f.label === periodRecurring)
                    ]
                  }
                  onChange={(e) => {
                    if (e.label) {
                      setPeriodRecurring(e.label);
                    }
                  }}
                />
              </Col>
            )}
            {periodRecurring === "Week" && (
              <Col md="12" className="m-top-10">
                <Form.Label style={{ color: themeConfig.text.primary }}>Repeat on:</Form.Label>{" "}
                <br />
                {dataButtonDays.map((element, index) => {
                  return (
                    <ContainFormCheck>
                      <FormLabelCheck>
                        <FormForCheck
                          inline
                          key={element.value}
                          type="checkbox"
                          required={activateRepeatEvery}
                          id={`${element.value}`}
                          name={`${element.value}`}
                          value={JSON.stringify(element)}
                          defaultChecked={
                            dataButtonDaysValue.findIndex(
                              (f) => f.value === element.value
                            ) === -1
                              ? false
                              : true
                          }
                          onChange={handleDayChange}
                        />{" "}
                        <span>{element.label}</span>
                      </FormLabelCheck>
                    </ContainFormCheck>
                  );
                })}
              </Col>
            )}
            {periodRecurring === "Month" && (
              <Col md="12">
                <Form.Label></Form.Label>
                <Select
                  placeholder="Monthly on ..."
                  options={optionForMonth}
                  required={activateRepeatEvery}
                  styles={SelectModalStyles}
                  defaultValue={
                    optionForMonthSelected?.value
                      ? optionForMonth[optionForMonthSelected?.value]
                      : ""
                  }
                  onChange={(e) => {
                    setOptionForMonthSelected(e);
                  }}
                />
              </Col>
            )}
            <Col md="12" className="m-top-10 ">
              <Form.Label style={{ color: themeConfig.text.primary, marginBottom: "0.3rem" }}>
                Ends:
              </Form.Label>{" "}
              <span style={{ color: themeConfig.status.error }}>*</span>
            </Col>
            {dataEndsDate.map((element, index) => (
              <Col md="12" className="d-flex m-top-5" key={index}>
                {element.value === "never" && (
                  <Col md="12" className={"mb-3"}>
                    <Form.Check
                      label={element.label}
                      type="radio"
                      id={`${element.value}`}
                      name={`${element.value}`}
                      value={element.value}
                      checked={activeEndsRecurring === "never" ? true : false}
                      onChange={(e) => {
                        setActiveEndsRecurring(`${e.currentTarget.value}`);
                      }}
                    />
                  </Col>
                )}
                {element.value === "on" && (
                  <Col md="12" calssName="m-top-5">
                    <Row>
                      <Col md="2" className="d-flex align-items-center">
                        <Form.Check
                          inline
                          label={element.label}
                          type="radio"
                          id={`${element.value}`}
                          name={`${element.value}`}
                          value={element.value}
                          checked={activeEndsRecurring === "on" ? true : false}
                          onChange={(e) => {
                            setActiveEndsRecurring(`${e.currentTarget.value}`);
                          }}
                        />
                      </Col>
                      <Col
                        md="4"
                        className="d-flex align-items-center"
                        style={{ padding: "0 10px" }}
                      >
                        <Form.Control
                          type="date"
                          required={activeEndsRecurring === "on" ? true : false}
                          disabled={activeEndsRecurring === "on" ? false : true}
                          value={
                            onEndRecurring?._i
                              ? onEndRecurring._i
                              : onEndRecurring
                          }
                          onChange={(e) => {
                            if (e.currentTarget.value !== "") {
                              setOnEndRecurring(
                                moment(e.currentTarget.value).format(
                                  "YYYY-MM-DD"
                                )
                              );
                            }
                          }}
                          placeholder="Feb 28, 2021"
                        />
                      </Col>
                      {!isEvent && (
                        <Col
                          md="6"
                          className="d-flex justify-space-between align-items-center"
                        >
                          <Form.Control
                            className="mr-2"
                            type="time"
                            required={
                              activeEndsRecurring === "on" ? true : false
                            }
                            disabled={
                              activeEndsRecurring === "on" ? false : true
                            }
                            value={
                              onEndTimeRecurring?._i
                                ? onEndTimeRecurring._i
                                : onEndTimeRecurring
                            }
                            onChange={(e) => {
                              if (e.currentTarget.value !== "") {
                                setOnEndTimeRecurring(
                                  moment(e.currentTarget.value)
                                );
                              }
                            }}
                            placeholder=""
                          />
                          {/*<b className="utc-label">UTC</b>
                          <Tooltip
                            arrow
                            className="ml-2"
                            title="Please take into account that all times are in UTC time when setting your survey recurrence"
                            placement="right"
                          >
                            <InfoIcon
                              style={{ color: themeConfig.primary.purple, cursor: "pointer" }}
                            />
                          </Tooltip>*/}
                        </Col>
                      )}
                    </Row>
                  </Col>
                )}
              </Col>
            ))}
            {/* <Hr className="my-0" /> */}
            <Col md="12" className="my-3">
              <SectionWrapper>
                <Row className="d-flex justify-content-end">
                  <Col md="4" style={{ textAlign: "center" }}>
                    <ButtonCancel
                      style={{ justifyContent: "center", cursor: "pointer" }}
                      onClick={() => closeRecurring()}
                    >
                      Cancel
                    </ButtonCancel>
                  </Col>
                  <Col md="4">
                    {!showUpdateRecurringButton ? (
                      <>
                        {loadingCreateRecurrence ? (
                          <PointersLine
                            className={"my-3"}
                            color={themeConfig.text.primary}
                          />
                        ) : (
                          <ButtonCreateGroup
                            disabled={loadingCreateRecurrence ? true : false}
                            onClick={() => createRecurring()}
                          >
                            Create
                          </ButtonCreateGroup>
                        )}
                      </>
                    ) : (
                      <>
                        {loadingCreateRecurrence ? (
                          <PointersLine
                            className={"my-3"}
                            color={themeConfig.text.primary}
                          />
                        ) : (
                          <ButtonCreateGroup
                            disabled={loadingCreateRecurrence ? true : false}
                            onClick={() => updateRecurring()}
                          >
                            Update
                          </ButtonCreateGroup>
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              </SectionWrapper>
            </Col>
          </Row>
        </FormCard>
      </PortalModal>
    </>
  );
};

export default ModalRecurrence;
